import { compose } from 'recompose';

import TabNavItemView from './TabNavItemView';

export default compose()(TabNavItemView);
